import BasicLayout from '@/layouts/basic-layout'

const prefix = 'storage-manage-tenant-manage-'
export default [
  {
    path: '/storage-manage/tenant-manage',
    redirect: {name: `${prefix}index`},
    component: BasicLayout,
    children: [
      {
        path: 'index',
        name: `${prefix}index`,
        meta: {title: '承租单位管理'},
        component: () => import('@/pages/storage-manage/tenant-manage/index')
      },
      {
        path: 'detail-edit/:id',
        name: `${prefix}edit`,
        auth: ['hidden'],
        meta: {cache: true, title: '承租单位编辑'},
        component: () => import('@/pages/storage-manage/tenant-manage/detail-edit')
      },
      {
        path: 'detail-create',
        name: `${prefix}create`,
        auth: ['hidden'],
        meta: {title: '承租单位新增'},
        component: () => import('@/pages/storage-manage/tenant-manage/detail-create')
      },
      {
        path: 'detail-view/:id',
        name: `${prefix}view`,
        auth: ['hidden'],
        meta: {title: '承租单位详情'},
        component: () => import('@/pages/storage-manage/tenant-manage/detail-view')
      },
      {
        path: 'company-detail-view',
        name: `${prefix}company-detail-view`,
        auth: ['hidden'],
        meta: {title: '企业信息'},
        component: () => import('@/pages/storage-manage/tenant-manage/company-detail-view')
      }
    ]
  }
]
